import {axiBasketball} from '@shared/api';

export interface MatchLsportsDTO {
  id: number;
  name: string | null;
  status: string | null;
  start_date: string | null;
  last_update: string | null;
}

export interface LeagueLsportsDTO {
  id: number;
  name: string;
  location_id: number;
  location_name: string;
}

export interface ParticipantLsportsDTO {
  id: number;
  name: string;
  position: number;
}

export interface MatchParticipantAdminDTO {
  id: string;
  team_id: string;
  lsports: ParticipantLsportsDTO | null;
}

export interface MatchLeagueAdminDTO {
  id: string;
  lsports: LeagueLsportsDTO | null;
}

export interface BasketballMatchAdminDTO {
  id: string;
  league: MatchLeagueAdminDTO;
  participants: MatchParticipantAdminDTO[];
  lsports: MatchLsportsDTO;
}

export const getBasketballMatch = async (
  matchId: string,
): Promise<BasketballMatchAdminDTO> => {
  const response = await axiBasketball.get<BasketballMatchAdminDTO>(
    `/admin/matches/${matchId}`,
  );
  return response.data;
};

export const BASKETBALL_QUARTER_MINUTES = [10, 12] as const;

export type BasketballQuarterMinutes =
  (typeof BASKETBALL_QUARTER_MINUTES)[number];

export interface BasketballLeagueAdminDTO {
  id: string;
  name: string;
  logo: string | null;
  api_sports_id: number | null;
  quarter_minutes: number;
}

export const getBasketballLeagues = async (): Promise<
  BasketballLeagueAdminDTO[]
> => {
  const response = await axiBasketball.get<BasketballLeagueAdminDTO[]>(
    '/admin/matches/leagues',
  );
  return response.data;
};

export interface UpdateBasketballLeagueQuarterMinutesParams {
  leagueId: string;
  quarterMinutes: BasketballQuarterMinutes;
}

export const updateBasketballLeagueQuarterMinutes = async ({
  leagueId,
  quarterMinutes,
}: UpdateBasketballLeagueQuarterMinutesParams): Promise<void> => {
  await axiBasketball.patch(`/admin/matches/leagues/${leagueId}`, {
    quarter_minutes: quarterMinutes,
  });
};
